module.exports = __webpack_public_path__ + "static/media/winIcon.7d19cd5f.svg";